import React from 'react';

import store, { actions } from '@store';

import { paths } from '@src/constants/pathsEnum';
import { safeMap } from '@src/utils/mapper';

import { Link } from '@commons/link/Link';

import Image from '@commons/image/Image';

import * as styles from './authors-details.module.scss';

export default function AuthorsDetails({ authors }) {
  return (
    <div className={styles.author} id="author-details">
      {safeMap(authors, ({ frontmatter: { name, surname, avatar, position } }, index) => (
        <div key={index} className={styles.bottom}>
          <div className={styles.avatar}>
            <Image image={avatar} alt={name} />
          </div>
          <div className={styles.details}>
            <div className={styles.name}>
              <p>
                <strong>
                  {name} {surname}
                </strong>
              </p>
            </div>
            <div className={styles.position}>
              <span>{position}</span>
            </div>
            <div
              className={styles.morebtn}
              onClick={() => store.dispatch(actions.changeSearchTerm(`${name} ${surname}`))}
            >
              <Link href={paths.BLOG}>More from this author</Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
